<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
  >
    <BannerNotification />
    <DNComponentUpdateHeader
      :title="instanceName"
      :componentName="componentName"
      :instanceId="instanceId"
      :draftId="draftId"
      :handleUpdate="handleUpdateInstance"
      :handleUpdateDraft="handleUpdateDraft"
      :handleCreateDraft="handleCreateDraft"
      :handleCopy="handleCopyInstance"
      :formData="formData"
    />
    <DNComponentUpdateForm
      :elementName="elementName"
      :componentId="componentId"
      :formData="formData"
      :attributesCategory="attributesCategory"
      :instanceId="instanceId"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import DNComponentUpdateHeader from "@/components/ComponentModule/DynamicNumComponent/DNComponentUpdateHeader.vue";
import DNComponentUpdateForm from "@/components/ComponentModule/DynamicNumComponent/DNComponentUpdateForm.vue";

export default {
  name: "DNComponentUpdatePage",
  components: {
    DNComponentUpdateHeader,
    DNComponentUpdateForm,
    BannerNotification
  },
  data() {
    return { formData: {} };
  },
  props: {
    elementName: {
      type: String,
      required: true
    },
    componentId: {
      type: String,
      required: true
    },
    attributesCategory: {
      type: Object,
      required: true
    },
    instanceId: {
      type: String,
      required: true
    }
  },
  async mounted() {
    await this.$store.dispatch(Actions.FETCH_COMPONENT_DATA, {
      region: this.getRegion,
      componentId: this.componentId
    });
  },
  unmounted() {
    // when unmount set to instance edit mode
    this.$store.dispatch(Actions.SET_DRAFT_MODE, { status: "no" });
  },
  watch: {
    instanceId() {
      // when instance id change set to instance edit mode
      this.$store.dispatch(Actions.SET_DRAFT_MODE, { status: "no" });
    },
    getInstanceInfo() {
      if (this.getInstanceInfo && this.getInstanceInfo.length) {
        let attributes = this.getInstanceInfo.find((item) => {
          return item.id === this.instanceId;
        }).attributes;
        this.formData = attributes;
      }
    },
    draftAndInstance() {
      if (
        this.getInstanceDraft &&
        this.getInstanceDraft.length &&
        this.draftModeStatus === "yes"
      ) {
        let attributes = this.getInstanceDraft.find((item) => {
          return item.instance_name === this.instanceName;
        }).attributes;
        this.formData = attributes;
      } else if (
        this.getInstanceInfo &&
        this.getInstanceInfo.length &&
        this.draftModeStatus === "no"
      ) {
        let attributes = this.getInstanceInfo.find((item) => {
          return item.id === this.instanceId;
        }).attributes;
        this.formData = attributes;
      }
    }
  },
  computed: {
    draftAndInstance() {
      const { getInstanceDraft, getInstanceInfo, draftModeStatus } = this;
      return { getInstanceDraft, getInstanceInfo, draftModeStatus };
    },
    draftId() {
      if (
        this.getInstanceDraft.length &&
        this.getInstanceDraft.find((item) => {
          return item.instance_name === this.instanceName;
        })
      ) {
        return this.getInstanceDraft.find((item) => {
          return item.instance_name === this.instanceName;
        }).id;
      } else {
        return "";
      }
    },
    instanceName() {
      if (
        this.getInstanceInfo.find(
          (item) => item.id === this.$route.params.instanceId
        )
      ) {
        return this.getInstanceInfo.find(
          (item) => item.id === this.$route.params.instanceId
        ).instance_name;
      } else {
        return "";
      }
    },
    componentName() {
      if (
        this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        )
      ) {
        return this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        ).name;
      } else {
        return "";
      }
    },
    ...mapGetters([
      "getAllComponent",
      "getInstanceInfo",
      "getInstanceDraft",
      "currentUser",
      "getRegion",
      "draftModeStatus"
    ])
  },
  methods: {
    handleUpdateInstance() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch(Actions.UPDATE_COMPONENT_DATA, {
            formData: this.formData,
            user: this.currentUser.email,
            region: this.getRegion,
            instanceId: this.instanceId,
            currentUrl: window.location.href
          })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    handleCopyInstance() {
      this.$store
        .dispatch(Actions.COPY_COMPONENT_DATA, {
          formData: this.formData,
          region: this.getRegion,
          componentId: this.componentId,
          title: this.instanceName.split("|")[1],
          user: this.currentUser.email
        })
        .then(() => {
          this.$router.push({ path: `/component/${this.componentId}` });
        });
    },
    handleCreateDraft() {
      const draftData = {
        attributes: this.formData,
        instance_name: this.instanceName.split("|")[1]
      };
      this.$store
        .dispatch(Actions.CREATE_DRAFT_INSTANCE, {
          formData: draftData,
          region: this.getRegion,
          componentId: this.componentId,
          user: this.currentUser.email
        })
        .then(() => {
          this.$store.dispatch(Actions.FETCH_DRAFT_INFO, {
            region: this.getRegion,
            componentId: this.componentId
          });
        });
    },
    handleUpdateDraft() {
      this.$store.dispatch(Actions.UPDATE_DRAFT_INSTANCE, {
        formData: this.formData,
        region: this.getRegion,
        draftId: this.draftId,
        user: this.currentUser.email
      });
    }
  }
};
</script>
